import type { FlowDef } from '../flow'
import { amendmentFlow } from './amendment'
import { cropInputsFlow } from './crop-inputs'
import { buildingInspectionFlow, equipmentFlow, hygieneFlow, pestCheckFlow, trainingFlow, visitorFlow } from './farm-level'
import { fertilizerFlow } from './fertilizer'
import { fieldTaskFlow } from './field-task'
import { harvestFlow } from './harvest'
import { packingFlow, shipmentFlow } from './product'
import { scoutingFlow } from './scouting'
import { sprayFlow } from './spray'

const ALL: FlowDef[] = [cropInputsFlow, sprayFlow, fertilizerFlow, amendmentFlow, harvestFlow, scoutingFlow, fieldTaskFlow, packingFlow, shipmentFlow, equipmentFlow, buildingInspectionFlow, hygieneFlow, pestCheckFlow, visitorFlow, trainingFlow]

/** Every kind of entry the wizard can log, by `kind` (also what a draft stores). */
export const FLOWS: Record<string, FlowDef> = Object.fromEntries(ALL.map((f) => [f.kind, f]))

export const flowFor = (kind: string | undefined): FlowDef | undefined => (kind ? FLOWS[kind] : undefined)
